import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { mainURL } from '../utils/common';
import { LicenceLeftMenu } from '../components/LicenceLeftMenu';
import { LeftSocialMediaIconUI } from '../components/LeftSocialMediaIconUI';

const Requirements_For_Obtaining_CE  = () => {
  const fileDownload=(fileStoreId)=>
  {
    
    let url=`${mainURL}/pwc-db-services/getPortalFiles`
     axios
        .post(url,{"fileId": fileStoreId, "userId": "392" })
        .then((res) => {
            console.log("response is --- ", res);

            if(res && res.data && res.status === 200) {
              const base64 = res.data[0] && res.data[0].base64_data;
              const pdfData = 'data:application/pdf;base64,'+base64;

              let html = '<html>' +
                  '<style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style>' +
                  '<body>' +
                  '<iframe src="' + pdfData + '"></iframe>' +
                  '</body></html>';
                  console.log(html);
              let a = window.open();
              a.document.write(html);
          }
        })
        .catch((e) => {
            // setLoader(false);
            console.log("The error is ", e);
        })
  }
const increaseFontSizeBy1px =() => {
    var el = document.getElementsByClassName('fontSizeClass');
    for (let i = 0; i < el.length; i++) {
      var style = window.getComputedStyle(el[i], null).getPropertyValue('font-size');
      var fontSize = parseFloat(style); 
      el[i].style.fontSize = (fontSize + 1) + 'px';
    }
  };
  const decreaseFontSizeBy1px =() => {
    var el = document.getElementsByClassName('fontSizeClass');
    for (let i = 0; i < el.length; i++) {
    var style = window.getComputedStyle(el[i], null).getPropertyValue('font-size');
    var fontSize = parseFloat(style); 
    el[i].style.fontSize = (fontSize - 1) + 'px'; 
    }
  };
  const { t, i18n, ready } = useTranslation();
  return (
    <>
  <section id="hero" className="hero hero2">
  <LeftSocialMediaIconUI />
    
    <div className="carousel-item active">
      <img src="assets/img/inner-bg2.png" className="img-fluid" alt="image" />      
    </div>
  </section>
  <section className="section inner-pad1">
    <div className="container " >
      <div className="row">
      <div className="col-lg-3">
          <div className="site-menu  min-height-400">
            <LicenceLeftMenu />
          </div>
        </div>
        <div className="col-lg-9">
         <div className="container">
          <div className="row">
            <div className="inner-title2">
              <h3 className="fontSizeClass"> {t("Requirements For Obtaining CE")} </h3>
            </div>
            <div className="col-lg-12 about-head1">
              <h4 className="fontSizeClass">
                
                {t("Only two documents are required for New CE. (All copies shall be self-attested)")}
              </h4>
              <p className="fontSizeClass">
                
                <strong>(i) {t("Identity proof documents")}:</strong> <br />
               {t(" Any Photo Identity Documents (EPIC/AADHAAR/DRIVING LICENCE/PASSPORT etc.) issued by Government authority as Identity proof as well as proof of residential proof of applicant.")}
              </p>
              <p className="fontSizeClass">
                
                <strong>(ii) {t("Proof of ownership/occupancy")}:</strong> <br />
                {t("Anyone of the following documents as occupancy proof of business address.")}
              </p>
              <p className="fontSizeClass">
                 {t("Property tax bill/property tax receipt/ Deed of Conveyance/Lease deed/Sublease deeds/Leave and license agreement/Rent receipt/Rent Agreement/No objection certificate if it is rent free/Electricity bill/Telephone bill/in respects of the place of business and in the name of applicant.")}
              </p>
              <p className="fontSizeClass">
                
                <strong> {t("Note I")} : </strong> {t("For trades where statutory certificates, licenses, permissions, permits are required to be Obtained by traders, production of such certificates, licenses, permissions, permits are not required Prior to and/or at the time of issuance/renewal of Certificates.")}
              </p>
              <p className="fontSizeClass">
                <strong> {t("Note II")} . </strong> {t("However, such enlistment or renewal thereof shall not absolve such person from any liability to take out any licence under any other law like Fire license/Fire No objection Certificate/Pollution Control Board Certificate/Clinical or Health Certificates/Excise(liquor) Deptt./RBI/SEBI/Customs/Police/Import Export etc. and alike for the time being in force.")}
              </p>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

  )
}

export default Requirements_For_Obtaining_CE